import React, { createContext, useContext, useEffect, useState } from "react";
import { authorizedGet } from "../helpers/api/api";
import CustomLoader from "../components/common/loader";
const OrgTheme = createContext();

//const domainName = window.location.hostname;

const domainName =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_API_ENDPOINT?.replace("https://", "")
    : window.location.hostname;

const OrganizationThemeContext = ({ children }) => {
  const [themeLogin, setThemeLogin] = useState();
  const handleApiTheme = async () => {
    // let res = await authorizedGet({
    //   uri: `/api/v1/me/`,
    // });
    // if(res){
    //   setThemeLogin(res.membership.organization);
    // }
    //else {

    // let test_res = await authorizedGet({
    //   uri: `/api/v1/accounts/organization_content/no-db?domain=${domainName}`,
    // });

    let res = await authorizedGet({
      uri: `/api/v1/accounts/organization_content/?domain=${domainName}`,
    });

    
    if (res?.results) {
      setThemeLogin(res?.results);
      //for updating favicon from the api
      // const favicon = document.getElementById("favicon");
      // const favIconImg = localStorage.getItem("favIconImg");
      // if(favIconImg){
      //   if(favIconImg !== res.results.logo){
      //     favicon.href = res.results.logo
      //   localStorage.setItem("favIconImg", res.results.logo)
      //   }
      // }else{
      //   favicon.href = res.results.logo
      //   localStorage.setItem("favIconImg", res.results.logo)
      // }
    }
    // }
  };
  useEffect(() => {
    handleApiTheme();
  }, []);

  //console.log("text data", themeLogin);
  return (
    <OrgTheme.Provider value={{ themeLogin }}>
      {typeof themeLogin === "undefined" ? (
        children
      ) : themeLogin ? (
        children
      ) : (
        <CustomLoader />
      )}
    </OrgTheme.Provider>
  );
};

export const OrganizationThemeState = () => {
  return useContext(OrgTheme);
};

export default OrganizationThemeContext;